import React from 'react';
import { Grid, TextField, Typography, MenuItem, Paper, FormControlLabel, Checkbox, Table, TableBody, TableCell, TableHead, TableRow  } from '@material-ui/core';
import { FormHelperText } from '@material-ui/core';
import TablaSesiones from "../../components/TablaSesiones";
import { FORM_DICTIONARY } from '../schemas/formFields';

/* =============================================
    PASO 1: Motivo y Antecedentes
   ============================================= */
function PasoMotivoComunicativo({ data, onChange }) {
    const safeValue = (field) => (data?.[field]?.valor || '');
    const safeError = (field) => data?.[field]?.error || '';
    const campos_generales = FORM_DICTIONARY.fichas.general;
    const campos_comunicativos = FORM_DICTIONARY.fichas.comunicativa;

    return (
        <Grid container spacing={2}>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={campos_generales.nombre_eps.label}
                    name={campos_generales.nombre_eps.name}
                    value={safeValue(campos_generales.nombre_eps.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.nombre_eps.name)}
                    helperText={safeError(campos_generales.nombre_eps.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    select
                    label={campos_generales.sisben.label}
                    name={campos_generales.sisben.name}
                    value={safeValue(campos_generales.sisben.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.sisben.name)}
                    helperText={safeError(campos_generales.sisben.name)}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={campos_generales.no_vinculado.label}
                    name={campos_generales.no_vinculado.name}
                    value={safeValue(campos_generales.no_vinculado.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.no_vinculado.name)}
                    helperText={safeError(campos_generales.no_vinculado.name)}
                />
            </Grid>


            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={campos_generales.grupo_priorizado.label}
                    name={campos_generales.grupo_priorizado.name}
                    value={safeValue(campos_generales.grupo_priorizado.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.grupo_priorizado.name)}
                    helperText={safeError(campos_generales.grupo_priorizado.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={campos_generales.se_auto_reconoce_grupo_priorizado.label}
                    name={campos_generales.se_auto_reconoce_grupo_priorizado.name}
                    value={safeValue(campos_generales.se_auto_reconoce_grupo_priorizado.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.se_auto_reconoce_grupo_priorizado.name)}
                    helperText={safeError(campos_generales.se_auto_reconoce_grupo_priorizado.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    select
                    label={campos_generales.certificado_grupo_priorizado.label}
                    name={campos_generales.certificado_grupo_priorizado.name}
                    value={safeValue(campos_generales.certificado_grupo_priorizado.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.certificado_grupo_priorizado.name)}
                    helperText={safeError(campos_generales.certificado_grupo_priorizado.name)}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={campos_comunicativos.remitido_por.label}
                    name={campos_comunicativos.remitido_por.name}
                    value={safeValue(campos_comunicativos.remitido_por.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.remitido_por.name)}
                    helperText={safeError(campos_comunicativos.remitido_por.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={campos_comunicativos.diagnostico_comunicativo.label}
                    name={campos_comunicativos.diagnostico_comunicativo.name}
                    value={safeValue(campos_comunicativos.diagnostico_comunicativo.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.diagnostico_comunicativo.name)}
                    helperText={safeError(campos_comunicativos.diagnostico_comunicativo.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={campos_comunicativos.examenes_adjuntos.label}
                    name={campos_comunicativos.examenes_adjuntos.name}
                    value={safeValue(campos_comunicativos.examenes_adjuntos.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.examenes_adjuntos.name)}
                    helperText={safeError(campos_comunicativos.examenes_adjuntos.name)}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField 
                    fullWidth multiline rows={3} variant="outlined" 
                    label={campos_comunicativos.antecedentes_comunicativos_detalle.label}
                    name={campos_comunicativos.antecedentes_comunicativos_detalle.name} 
                    value={safeValue(campos_comunicativos.antecedentes_comunicativos_detalle.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.antecedentes_comunicativos_detalle.name)}
                    helperText={safeError(campos_comunicativos.antecedentes_comunicativos_detalle.name)}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField 
                    fullWidth 
                    label={campos_comunicativos.antecedentes_familiares_comunicativos.label}
                    name={campos_comunicativos.antecedentes_familiares_comunicativos.name}
                    value={safeValue(campos_comunicativos.antecedentes_familiares_comunicativos.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.antecedentes_familiares_comunicativos.name)}
                    helperText={safeError(campos_comunicativos.antecedentes_familiares_comunicativos.name)}
                />
            </Grid>
        </Grid>
    );
}

/* =============================================
    PASO 2: Aspecto Socio-Afectivo
   ============================================= */
function PasoSocialComunicativo({ data, onChange }) {
    const safeValue = (field) => (data?.[field]?.valor || '');
    const safeError = (field) => data?.[field]?.error || '';
    const campos_comunicativos = FORM_DICTIONARY.fichas.comunicativa;

    return (
        <Grid container spacing={2}>

            <Grid item xs={12}>
                <TextField
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    label={campos_comunicativos.motivo_asesoria_comunicativa.label}
                    name={campos_comunicativos.motivo_asesoria_comunicativa.name}
                    value={safeValue(campos_comunicativos.motivo_asesoria_comunicativa.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.motivo_asesoria_comunicativa.name)}
                    helperText={safeError(campos_comunicativos.motivo_asesoria_comunicativa.name)}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField 
                    fullWidth 
                    label={campos_comunicativos.con_quien_vive.label}
                    name={campos_comunicativos.con_quien_vive.name}
                    value={safeValue(campos_comunicativos.con_quien_vive.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.con_quien_vive.name)}
                    helperText={safeError(campos_comunicativos.con_quien_vive.name)}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label={campos_comunicativos.ocupacion_familiar.label}
                    name={campos_comunicativos.ocupacion_familiar.name}
                    value={safeValue(campos_comunicativos.ocupacion_familiar.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.ocupacion_familiar.name)}
                    helperText={safeError(campos_comunicativos.ocupacion_familiar.name)}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label={campos_comunicativos.info_hermanos.label}
                    name={campos_comunicativos.info_hermanos.name}
                    value={safeValue(campos_comunicativos.info_hermanos.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.info_hermanos.name)}
                    helperText={safeError(campos_comunicativos.info_hermanos.name)}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label={campos_comunicativos.comunicacion_familiar.label}
                    name={campos_comunicativos.comunicacion_familiar.name}
                    value={safeValue(campos_comunicativos.comunicacion_familiar.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.comunicacion_familiar.name)}
                    helperText={safeError(campos_comunicativos.comunicacion_familiar.name)}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    label={campos_comunicativos.actividades_tiempo_libre.label}
                    name={campos_comunicativos.actividades_tiempo_libre.name}
                    value={safeValue(campos_comunicativos.actividades_tiempo_libre.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.actividades_tiempo_libre.name)}
                    helperText={safeError(campos_comunicativos.actividades_tiempo_libre.name)}
                />
            </Grid>

        </Grid>
    );
}

/* =============================================
    PASO 3: Habilidades y Percepción del Habla
   ============================================= */
function PasoHabilidades({data, onChange }) {
    const safeValue = (field) => (data?.[field]?.valor || '');
    const safeBool = (field) => !!data?.[field]?.valor;
    const safeError = (field) => data?.[field]?.error || '';
    const campos_comunicativos = FORM_DICTIONARY.fichas.comunicativa;

    const habilidades = [
        { label: campos_comunicativos.habcom_leer.label, name: campos_comunicativos.habcom_leer.name },
        { label: campos_comunicativos.habcom_escribir.label, name: campos_comunicativos.habcom_escribir.name },
        { label: campos_comunicativos.habcom_escuchar.label, name: campos_comunicativos.habcom_escuchar.name },
        { label: campos_comunicativos.habcom_hablar.label, name: campos_comunicativos.habcom_hablar.name }
    ];

    return (
        <Grid container spacing={2}>

            <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" gutterBottom>Habilidades Comunicativas:</Typography>
                    <Paper elevation={0}>
                        {habilidades.map(h => (
                            <FormControlLabel
                                key={h.name}
                                control={<Checkbox checked={safeBool(h.name)} onChange={(e) => onChange({ target: { name: h.name, value: e.target.checked } })} color="primary" />}
                                label={h.label}
                            />
                        ))}
                    </Paper>
                <FormHelperText error>{safeError('habilidades_comunicativas')}</FormHelperText>
            </Grid>

            <Grid item xs={12}>
                <TablaPercepcion data={data} onChange={onChange} />
            </Grid>

            <Grid item xs={12}>
                <TextField 
                    fullWidth multiline rows={2} variant="outlined"
                    label={campos_comunicativos.necesidad_escribir_leer.label}
                    name={campos_comunicativos.necesidad_escribir_leer.name}
                    value={safeValue(campos_comunicativos.necesidad_escribir_leer.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.necesidad_escribir_leer.name)}
                    helperText={safeError(campos_comunicativos.necesidad_escribir_leer.name)}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField 
                    fullWidth multiline rows={2} variant="outlined"
                    label={campos_comunicativos.necesidad_comunicacion.label}
                    name={campos_comunicativos.necesidad_comunicacion.name}
                    value={safeValue(campos_comunicativos.necesidad_comunicacion.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.necesidad_comunicacion.name)}
                    helperText={safeError(campos_comunicativos.necesidad_comunicacion.name)}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField 
                    fullWidth multiline rows={2} variant="outlined"
                    label={campos_comunicativos.necesidad_recepcion_informacion.label}
                    name={campos_comunicativos.necesidad_recepcion_informacion.name}
                    value={safeValue(campos_comunicativos.necesidad_recepcion_informacion.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.necesidad_recepcion_informacion.name)}
                    helperText={safeError(campos_comunicativos.necesidad_recepcion_informacion.name)}
                />
            </Grid>
        </Grid>
    );
}

/* =============================================
    PASO 4: Desempeño Académico y Sesiones
   ============================================= */
function PasoFinalComunicativo({ data, onChange, onChangeSesion }) {
    const safeValue = (field) => (data?.[field]?.valor || '');
    const safeBool = (field) => !!data?.[field]?.valor;
    const safeError = (field) => data?.[field]?.error || '';
    const campos_comunicativos = FORM_DICTIONARY.fichas.comunicativa;

    const handleCheck = (e) => onChange({ target: { name: e.target.name, value: e.target.checked } });

    const handleSesionesChange = (nuevasSesiones) => {
        onChangeSesion(nuevasSesiones);
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
                <TextField
                    select
                    fullWidth
                    label={campos_comunicativos.desempeno_academico.label}
                    name={campos_comunicativos.desempeno_academico.name}
                    value={safeValue(campos_comunicativos.desempeno_academico.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.desempeno_academico.name)}
                    helperText={safeError(campos_comunicativos.desempeno_academico.name)}
                >
                    <MenuItem value="BUENO">Bueno</MenuItem>
                    <MenuItem value="REGULAR">Regular</MenuItem>
                    <MenuItem value="MALO">Malo</MenuItem>
                </TextField>
            </Grid>
            <Grid item xs={12} md={8}>
                <Paper elevation={0} style={{ padding: 5, display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                    {['Inspeccionar', 'Preguntar', 'Leer', 'Escribir', 'Repasar', 'Otra'].map(habito => (
                        <FormControlLabel
                            key={habito}
                            control={<Checkbox checked={safeBool(`hab_${habito}`)} onChange={handleCheck} name={`hab_${habito}`} />}
                            label={habito}
                        />
                    ))}
                </Paper>
                <FormHelperText error>{safeError('habitos_estudio')}</FormHelperText>
            </Grid>
            <Grid item xs={12}>
                <TextField 
                    fullWidth multiline rows={2} variant="outlined"
                    label={campos_comunicativos.desempeno_academico_influenciado.label}
                    name={campos_comunicativos.desempeno_academico_influenciado.name}
                    value={safeValue(campos_comunicativos.desempeno_academico_influenciado.name)} 
                    onChange={onChange}
                    required
                    error={!!safeError(campos_comunicativos.desempeno_academico_influenciado.name)}
                    helperText={safeError(campos_comunicativos.desempeno_academico_influenciado.name)}
                />
            </Grid>
            <Grid item xs={12}>
                <TablaSesiones
                sesiones={data.sesiones}
                onChange={handleSesionesChange}
                />
            </Grid>
        </Grid>
    );
}

/* =============================================
    EXPORTACIÓN DE PASOS
   ============================================= */
export const StepsAsesoriaComunicativa = [
    { label: 'Antecedentes', render: (props) => <PasoMotivoComunicativo {...props} /> },
    { label: 'Socio-Afectivo', render: (props) => <PasoSocialComunicativo {...props} /> },
    { label: 'Habilidades Habla/Lectura', render: (props) => <PasoHabilidades {...props} /> },
    { label: 'Desempeño y Sesión', render: (props) => <PasoFinalComunicativo {...props} /> }
];


function TablaPercepcion({ data, onChange }) {
    const safeValue = (field) => (data?.[field]?.valor || '');
        const safeError = (field) => data?.[field]?.error || '';
        const campos_comunicativos = FORM_DICTIONARY.fichas.comunicativa;

    const preguntas = [
        { label: campos_comunicativos.personas_entienden_comunicacion.label, name: campos_comunicativos.personas_entienden_comunicacion.name },
        { label: campos_comunicativos.pryeccion_voz_adecuada.label, name: campos_comunicativos.pryeccion_voz_adecuada.name },
        { label: campos_comunicativos.habla_rapido.label, name: campos_comunicativos.habla_rapido.name },
        { label: campos_comunicativos.habla_lento.label, name: campos_comunicativos.habla_lento.name },
        { label: campos_comunicativos.muletillas.label, name: campos_comunicativos.muletillas.name }
    ];

    const opciones = ["SI", "NO", "ALGUNAS_VECES"];

    const handleChange = (name, valor) => {
        onChange({
        target: {
            name,
            value: valor
        }
        });
    };

    return (
        <Paper elevation={0}>
        <Table size="small">
            <TableHead>
            <TableRow>
                <TableCell></TableCell>
                <TableCell align="center">Sí</TableCell>
                <TableCell align="center">No</TableCell>
                <TableCell align="center">Algunas veces</TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {preguntas.map((pregunta) => (
                <TableRow key={pregunta.name}>
                <TableCell>
                    {pregunta.label}
                    {safeError(pregunta.name) && (
                        <FormHelperText error>{safeError(pregunta.name)}</FormHelperText>
                    )}
                </TableCell>

                {opciones.map((op) => (
                    <TableCell align="center" key={op}>
                    <Checkbox
                        checked={safeValue(pregunta.name) === op}
                        onChange={() => handleChange(pregunta.name, op)}
                        color="primary"
                    />
                    </TableCell>
                ))}

                </TableRow>
            ))}
            </TableBody>
        </Table>
        </Paper>
    );
}